import { h } from '@/lib/dom';

interface PinButtonProps {
  isPinned: boolean;
  isLoading: boolean;
  onToggle: () => void;
}

export function PinButton({ isPinned, isLoading, onToggle }: PinButtonProps): HTMLElement {
  const label = isPinned ? '📌 Приоритетный' : '☐ Закрепить';
  const ariaLabel = isPinned ? 'Открепить из приоритетных' : 'Закрепить как приоритетный';

  const btn = h('button', {
    type: 'button',
    class: `btn btn-secondary btn-sm pin-btn${isPinned ? ' pin-btn--pinned' : ''}`,
    'aria-pressed': isPinned ? 'true' : 'false',
    'aria-label': ariaLabel,
    'aria-busy': isLoading ? 'true' : undefined,
    on: { click: onToggle },
  }, isLoading ? '⟳ ' + (isPinned ? 'Приоритетный' : 'Закрепить') : label) as HTMLButtonElement;

  if (isLoading) {
    (btn as HTMLButtonElement).disabled = true;
  }

  return btn;
}
